/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_Meta_TitleInputs */

const en_directory_vibebids_meta_title = /** @type {(inputs: Directory_Vibebids_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VibeBids | Live product bidding board`)
};

const zh_directory_vibebids_meta_title = /** @type {(inputs: Directory_Vibebids_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VibeBids | 实时产品竞榜`)
};

/**
* | output |
* | --- |
* | "VibeBids \| Live product bidding board" |
*
* @param {Directory_Vibebids_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_meta_title = /** @type {((inputs?: Directory_Vibebids_Meta_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Meta_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_meta_title(inputs)
	return zh_directory_vibebids_meta_title(inputs)
});
export { directory_vibebids_meta_title as "directory.vibebids.meta_title" }